import React, { useEffect, useState } from 'react';
import './SNB.scss';
import { TABS_IN_USE } from './tabs';
import TabSection from './organisms/TabSection';
import iconMenu from '../../assets/images/icon_menu.png';
import Logo from '../../assets/images/Logo_EQHub.png';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ACCOUNT_COLGROUP, ACCOUNT_HEADERS } from '../../service/tokenization/components/manager/account/AccountManager';
import KitContainer from '../../service/tokenization/components/KitContainer';
import BasicButton from '../../components/_atom/button/BasicButton';
import { ButtonSize, ButtonTheme } from '../../components/_atom/button/StyledButton';
import PageLoading from '../../components/_atom/loading/PageLoading';
import EmptyDataTemplate from '../../service/dashboard/components/EmptyDataTemplate';
import BasicTable from '../../components/_atom/table/BasicTable';
import { PagingBar } from '../../components/_atom/paging/PagingBar';
import toast from 'react-hot-toast';
import { formatDateToLocal } from '../../../utils/TimeUtils';
import { logic } from '../../../logic';
import useLoading from '../../../hooks/useLoading';
import { ReactComponent as IconCopy } from '../../../view/assets/images/icon_copy.svg';
import CreateAccountModal from '../../service/tokenization/components/manager/account/CreateAccountModal';
import ModalTemplateB from '../../components/_template/modal/ModalTemplateB';
import CopyToClipboard from '../../service/tokenization/components/CopyToClipboard';
import { Account } from '../../assets/constant/accountManager.type';
import AccountDepositCoinModal from '../../service/tokenization/components/manager/account/AccountDepositCoinModal';
import depositIcon from '../../assets/images/atom/icon_deposit.png';

const TABS = TABS_IN_USE;

const SNB = (props) => {
  const { isOpen, setIsOpen } = props;

  const [opendSubMenuList, setOpendSubMenuList] = useState([]);
  const [clickedMenu, setClickedMenu] = useState();
  const [isUserPanelOpen, setIsUserPanelOpen] = useState(false);
  const navigate = useNavigate();

  const [isAccountManagerModalOpen, setIsAccountManagerModalOpen] = useState(false);

  useEffect(() => {
    const userPanelHandleOutsideClose = (e) => {
      if (isUserPanelOpen) setIsUserPanelOpen(false);
    };
    document.addEventListener('click', userPanelHandleOutsideClose);
    return () => document.removeEventListener('click', userPanelHandleOutsideClose);
  }, [isUserPanelOpen]);

  return (
    <div id="SNB">
      <AccountManagerModal isOpen={isAccountManagerModalOpen} onClose={() => setIsAccountManagerModalOpen(false)} />
      {/*<div className="user-menu">*/}
      {/*  <div className="user-menu-info" onClick={() => setIsUserPanelOpen((prev) => !prev)}>*/}
      {/*    {isUserPanelOpen && <UserPanel setIsUserPanelOpen={setIsUserPanelOpen} ref={userPanelRef} />}*/}
      {/*    <div className="user-menu-info-icon">*/}
      {/*      <img src={userIcon} className="user-menu-info-icon-src" alt="" />*/}
      {/*    </div>*/}
      {/*    <div className="user-menu-info-label-wrapper">*/}
      {/*      <div className="user-menu-info-label">*/}
      {/*        <span className="user-menu-info-label-hello">Hello, </span>*/}
      {/*        <span className="user-menu-info-label-name">{`${userInfo.firstName} ${userInfo.lastName}`}</span>*/}
      {/*      </div>*/}
      {/*    </div>*/}
      {/*  </div>*/}
      {/*  <Notifications />*/}
      {/*</div>*/}
      {isOpen && <div className="overlay" onClick={() => setIsOpen(false)}></div>}
      <div className={`SNB-content-wrapper${isOpen ? ' open' : ''}`}>
        <div className="main-header-logo">
          <img src={iconMenu} className="main-header-menu" alt="=" onClick={() => setIsOpen(!isOpen)} />
          <img
            src={Logo}
            className="main-header-logo-src"
            alt="logo"
            onClick={() => {
              setIsOpen(!isOpen);
              navigate('/');
            }}
          />
        </div>
        <div className="nav-container">
          {TABS.map((tab) => (
            <TabSection
              tab={tab}
              key={`tab-section-${tab.index}`}
              opendSubMenuList={opendSubMenuList}
              setOpendSubMenuList={setOpendSubMenuList}
              clickedMenu={clickedMenu}
              setIsOpen={setIsOpen}
              setClickedMenu={(e) => {
                setClickedMenu(e);
              }}
              setModalOpen={setIsAccountManagerModalOpen}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default SNB;

const ACCOUNTS_LIMIT = 5;
const ACCOUNT_RENDERER = (data) => {
  return {
    id: (
      <div style={{ display: 'flex', gap: 10, paddingRight: 10 }}>
        <div
          title={data.account_id}
          style={{
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {data.account_id}
        </div>
        <CopyToClipboard
          text={data.account_id}
          onCopy={(e) => {
            e.stopPropagation();
            toast('Copied ID', { icon: '👏' });
          }}
        >
          <IconCopy style={{ minWidth: 20, minHeight: 20, objectFit: 'contain', cursor: 'pointer' }} className="icon-copy" />
        </CopyToClipboard>
      </div>
    ),
    name: (
      <div style={{ display: 'flex', gap: 10, paddingRight: 10, alignItems: 'center' }}>
        <div
          title={data.account_id}
          style={{
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {data.name}
        </div>
      </div>
    ),
    address: (
      <div style={{ display: 'flex', gap: 10, paddingRight: 10 }}>
        <div
          title={data.address}
          style={{
            maxWidth: '100%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {data.address}
        </div>
        <CopyToClipboard
          text={data.address}
          onCopy={(e) => {
            e.stopPropagation();
            toast('Copied Address', { icon: '👏' });
          }}
        >
          <IconCopy style={{ minWidth: 20, minHeight: 20, objectFit: 'contain', cursor: 'pointer' }} className="icon-copy" />
        </CopyToClipboard>
      </div>
    ),
    createdAt: formatDateToLocal(data.created_at),
    deposit: <img src={depositIcon} alt={'deposit'} style={{ width: 24, height: 24, objectFit: 'contain', borderRadius: 50 }} />,
  };
};

const AccountManagerModal = (props) => {
  const { isOpen, onClose } = props;
  const [selectedAccount, setSelectedAccount] = useState();
  const [isOpenDepositModal, setIsOpenDepositModal] = useState(false);

  const [accounts, setAccounts] = useState([]);
  const [maxAccountsNum, setMaxAccountsNum] = useState(0);
  const getAccounts = async (option) => {
    const { result, error } = await logic.accountManager.getAccountManagerList({
      limit: ACCOUNTS_LIMIT,
      ...option,
    });
    if (error) {
      return;
    }
    const { rows: accounts, count: maxAccountsNum } = result;
    setAccounts(accounts);
    setMaxAccountsNum(maxAccountsNum);
  };
  const [isOpenRegisterAccountModal, setIsOpenRegisterAccountModal] = useState(false);
  const [searchParams] = useSearchParams();
  const pageNum = Number(searchParams.get('account')) || 1;
  const maxPageNum = maxAccountsNum % ACCOUNTS_LIMIT === 0 ? maxAccountsNum / ACCOUNTS_LIMIT : Math.floor(maxAccountsNum / ACCOUNTS_LIMIT) + 1;
  const [refresh, setRefresh] = useState(false);
  const { loading } = useLoading({
    dependency: [pageNum, isOpen, refresh],
    synchronousFunction: async () => {
      await getAccounts({ offset: (pageNum - 1) * ACCOUNTS_LIMIT });
    },
  });
  return (
    <ModalTemplateB isOpen={isOpen} onRequestClose={onClose} title="Account Manager" isDisplayClose showDivideLine={false}>
      <CreateAccountModal
        refreshAccounts={() => setRefresh(!refresh)}
        isOpen={isOpenRegisterAccountModal}
        closeModal={() => setIsOpenRegisterAccountModal(false)}
      />
      <AccountDepositCoinModal account={selectedAccount} isOpen={isOpenDepositModal} closeModal={() => setIsOpenDepositModal(false)} />
      <KitContainer
        title={'Account List'}
        Button={
          <BasicButton size={ButtonSize.DYNAMIC} theme={ButtonTheme.PRIMARY} onClick={() => setIsOpenRegisterAccountModal(true)}>
            + New Account
          </BasicButton>
        }
        style={{ padding: 0, border: 'none', width: 810 }}
        buttonStyle={{ top: -7, right: 0 }}
      >
        {loading ? (
          <PageLoading style={{ height: 277 }} />
        ) : (
          <>
            {accounts.length === 0 ? (
              <EmptyDataTemplate>
                <div style={{ fontSize: 18, fontWeight: 500, lineHeight: '21px', color: '#7D828D' }}>There are no registered accounts yet.</div>
              </EmptyDataTemplate>
            ) : (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 10,
                  width: '100%',
                }}
              >
                <BasicTable
                  data={accounts}
                  colGroup={ACCOUNT_COLGROUP}
                  headers={ACCOUNT_HEADERS}
                  renderer={ACCOUNT_RENDERER}
                  onClick={(account) => {
                    setSelectedAccount(account);
                    setIsOpenDepositModal(true);
                  }}
                />
                <PagingBar maxPageNum={maxPageNum} query={'account'} />
              </div>
            )}
          </>
        )}
      </KitContainer>
      <div style={{ width: 200, marginTop: 40, justifySelf: 'center' }}>
        <BasicButton size={ButtonSize.DYNAMIC} theme={ButtonTheme.NORMAL} onClick={() => onClose()} style={{ width: '100%', height: 40, marginTop: 20 }}>
          Close
        </BasicButton>
      </div>
    </ModalTemplateB>
  );
};
